import React from "react";
import { IconPersonArrow } from "../../../../../../components/buttons/IconButtons";
import SummarySection from "../../../../../../components/Summary/SummarySection";
import SummaryContainerDetails from "./SummaryContainerDetails";
import SummaryContainerSchedules from "./SummaryContainerSchedules";
import SummaryContainerCustomAccess from "./SummaryContainerCustomAccess";
import SummaryContainerDepartments from "./SummaryContainerDepartments";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Final step of the create work shift flow. Read-only recap: details (name),
 * schedules, custom access (employees) and departments. Mirrors the ShiftAccess
 * Summary methodology.
 */
const Summary = ({
                     t,
                     item,
                     schedules = [],
                     user = [],
                     departments = [],
                 }) => {

    return (
        <>
            <SummarySection icon={IconPersonArrow} title={t('work_shift')}>
                <SummaryContainerDetails data={item} t={t} />
            </SummarySection>

            <SummaryContainerSchedules t={t} selected={schedules} />

            <SummaryContainerCustomAccess t={t} selected={user} />

            <SummaryContainerDepartments t={t} selected={departments} />
        </>
    );
};

export default Summary;
